import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                <i className="ri-sun-fill text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">蜜桃在线</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              您首选的在线娱乐平台，提供极速稳定的访问体验、丰富多样的内容资源与贴心的用户服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category?cat=hot" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">热门推荐</Link>
              </li>
              <li>
                <Link to="/category?cat=video" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">精彩视频</Link>
              </li>
              <li>
                <Link to="/category?cat=live" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">互动直播</Link>
              </li>
              <li>
                <Link to="/category?cat=game" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">休闲游戏</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500"></i>
                <span>service@mitaozaixian.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-primary-500"></i>
                <span>7×24小时在线客服</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-500"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 蜜桃在线 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}